import { makeAutoObservable } from "mobx";
export default class MainStore {

  constructor() {
    makeAutoObservable(this);
  }

  //General
  systemDomain = window.__UMS_THEME__?.serverUrl || process.env.REACT_APP_SERVER_URL;
  lang = "";
  menuNo = 0;
  menuType = 0;

  isMobileMenuOpen = false;

  setLang = (l) => {
    this.lang = l;
  };

  setMenuType = (tk) => {
    this.menuType = tk;
  };

  setMenuNo = (tk) => {
    this.menuNo = tk;
  };


  //Top MenuType

  HomeMenuType = 1000;
  HomeMenuNo = 200;

  ProfileMenuType = 1000;
  ProfileMenuNo = 1000;

  HelpMenuType = 1000;
  HelpMenuNo = 1001;

  SchedulePlanMenuType = 1000;
  SchedulePlanMenuNo = 1002;

  ReplacementScheduleMenuType = 1000;
  ReplacementScheduleMenuNo = 1006;

  EvaluationMenuType = 1000;
  EvaluationMenuNo = 1003;

  ExamRegistrationMenuType = 1000;
  ExamRegistrationMenuNo = 1004;

  GradeManagementMenuType = 1000;
  GradeManagementMenuNo = 1005;

  ExamPlanMenuType = 1000;
  ExamPlanMenuNo = 1007;



}
